import React from 'react';
import './Services.css';

const Services = () => {
    const services = [
        {
            id: 1,
            title: "Consulting & Strategy",
            description: "Expert guidance to help you make informed decisions and develop winning strategies.",
            icon: "🎯",
            details: [
                "Business Process Analysis",
                "Digital Transformation Planning",
                "Technology Roadmap Development",
                "Change Management Support"
            ]
        },
        {
            id: 2,
            title: "Implementation & Integration",
            description: "Seamless deployment and integration of solutions tailored to your business needs.",
            icon: "⚙️",
            details: [
                "System Implementation",
                "Data Migration Services",
                "Third-party Integrations",
                "Custom Development"
            ]
        },
        {
            id: 3,
            title: "Training & Support",
            description: "Comprehensive training programs and ongoing support to maximize your investment.",
            icon: "📚",
            details: [
                "User Training Programs",
                "Administrator Certification",
                "24/7 Technical Support",
                "Knowledge Base Access"
            ]
        },
        {
            id: 4,
            title: "Maintenance & Optimization",
            description: "Ongoing maintenance and optimization services to keep your systems running smoothly.",
            icon: "🔧",
            details: [
                "System Health Monitoring",
                "Performance Optimization",
                "Security Updates",
                "Backup & Recovery"
            ]
        }
    ];

    const testimonials = [
        {
            name: "Sarah Johnson",
            company: "TechCorp Inc.",
            quote: "The consulting team helped us streamline our processes and increase efficiency by 40%."
        },
        {
            name: "Michael Chen",
            company: "Global Solutions Ltd.",
            quote: "Outstanding implementation support. The project was delivered on time and within budget."
        },
        {
            name: "Emily Rodriguez",
            company: "Innovation Hub",
            quote: "Their training programs are comprehensive and really helped our team get up to speed quickly."
        }
    ];

    return (
        <div className="services-container">
            <div className="services-hero">
                <h1>Our Services</h1>
                <p>Comprehensive solutions and expert services to drive your business forward</p>
            </div>

            <div className="services-grid">
                {services.map(service => (
                    <div key={service.id} className="service-card">
                        <div className="service-icon">{service.icon}</div>
                        <h3>{service.title}</h3>
                        <p className="service-description">{service.description}</p>
                        <div className="service-details">
                            <ul>
                                {service.details.map((detail, index) => (
                                    <li key={index}>{detail}</li>
                                ))}
                            </ul>
                        </div>
                        <button className="service-button">Get Started</button>
                    </div>
                ))}
            </div>

            <div className="testimonials-section">
                <h2>What Our Clients Say</h2>
                <div className="testimonials-grid">
                    {testimonials.map((testimonial, index) => (
                        <div key={index} className="testimonial-card">
                            <p className="testimonial-quote">"{testimonial.quote}"</p>
                            <div className="testimonial-author">
                                <strong>{testimonial.name}</strong>
                                <span>{testimonial.company}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="services-cta">
                <h2>Ready to Get Started?</h2>
                <p>Contact us today to discuss how our services can help your business succeed.</p>
                <div className="cta-buttons">
                    <button className="primary-cta">Schedule Consultation</button>
                    <button className="secondary-cta">View Case Studies</button>
                </div>
            </div>
        </div>
    );
};

export default Services;
